import React, { useEffect, useRef } from "react";
import styled from "styled-components";
import { motion } from "framer-motion";
import Home from "./Home";
import About from "./About";
import Projects from "./Projects";
import Contact from "./Contact";
import BackToTop from "../components/BackToTop";

const MainPage = ({ projects }) => {
  const homeRef = useRef(null);
  const aboutRef = useRef(null);
  const projectsRef = useRef(null);
  const contactRef = useRef(null);

  useEffect(() => {
    // Handle hash navigation
    const handleHashChange = () => {
      const hash = window.location.hash;
      if (hash) {
        const section = document.querySelector(hash);
        if (section) {
          section.scrollIntoView({ behavior: "smooth" });
        }
      }
    };

    // Check hash on initial load
    handleHashChange();

    // Add listener for hash changes
    window.addEventListener('hashchange', handleHashChange);
    return () => {
      window.removeEventListener('hashchange', handleHashChange);
    };
  }, []);

  return (
    <StyledMainPage>
      <section id="home" ref={homeRef} className="section section-home">
        <Home />
      </section>

      <section id="about" ref={aboutRef} className="section section-about">
        <div className="section-content">
          <About />
        </div>
      </section>

      <section id="projects" ref={projectsRef} className="section section-projects">
        <div className="section-content">
          <Projects projects={projects} />
        </div>
      </section>
      <BackToTop /> 

      <section id="contact" ref={contactRef} className="section section-contact">
        <div className="section-content">
          <Contact />
        </div>
      </section>
    </StyledMainPage>
  );
};

const StyledMainPage = styled.div`
  position: relative;
  width: 100%;
  overflow-x: hidden;

  .section {
    width: 100%;
    min-height: 100vh;
    position: relative;
    padding: 2rem 0;
    /* overflow: hidden; */
    
    &:nth-child(even) {
      background-color: rgba(var(--primary-background-rgb), 0.2);
    }

    &-home {
      min-height: 100vh;
      padding: 0;
      margin-top: 0;
      
      .section-content {
        padding: 0;
      }
    }

    &-contact {
      padding-bottom: 0;
      min-height: 90vh; /* Changed from 75vh to 100vh to take full screen height with footer */
      align-items: center;
      display: flex;
    }
  }

  .section-content {
    width: 90%;
    max-width: 1200px;
    margin: 0 auto;
    padding: 2rem 0;

    /* Reset internal padding for components to avoid double padding */
    & > div {
      padding: 0 !important;
      min-height: unset !important;
    }
  }
  
  @media only screen and (max-width: 768px) {
    .section {
      padding: 1rem 0;
    }
    
    .section-content {
      width: 95%;
      padding: 1rem 0;
    }
  }
`;

const SectionHeader = styled.div`
  width: 90%;
  max-width: 1200px;
  margin: 0 auto;
  padding-top: 4rem;
  
  .section-title {
    font-size: 2.5rem;
    margin-bottom: 2rem;
    position: relative;
    display: inline-block;
    color: var(--heading-text);
  }
   
  @media only screen and (max-width: 768px) {
    padding-top: 3rem;
    
    .section-title {
      font-size: 2rem;
    }
  }
`;

export default MainPage;